import React from 'react';
import { Button } from './ui/Button';
import { MicIcon } from 'lucide-react';
export function Future() {
  return <section className="w-full py-20 px-6 md:px-10 lg:px-20 bg-gradient-to-b from-[#111] to-[#111]/90 relative overflow-hidden" data-id="element-107">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#111] via-[#111] to-[#3F00FF]/20 z-0" data-id="element-108"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-109">
        <div className="text-center" data-id="element-110">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-111">
            The Future is <span className="text-[#00E0FF]" data-id="element-112">Voice-First</span>
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto" data-id="element-113">
            Typing is dead. Scripted chatbots are dying. The future of business
            interaction is voice-first, AI-native, and emotionally intelligent.
            And Critical Voice is the platform that makes it happen — right now.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-114">
            <a href="https://ai-therapist-production.up.railway.app/" target="_blank" rel="noopener noreferrer" data-id="element-115">
              <Button size="large" data-id="element-116">
                <MicIcon className="w-5 h-5 mr-2" data-id="element-117" />
                Get Started Today
              </Button>
            </a>
            <a href="https://ai-therapist-production.up.railway.app/" target="_blank" rel="noopener noreferrer" data-id="element-118">
              <Button variant="outline" size="large" data-id="element-119">
                Request a Demo
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}